import { Flex, Row, Col } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import { CopyButton } from "./CopyButton"
import styles from "./CustomEmailTab.module.css"

const RecordRow = ({ record }) => (
  <Row gutter={12} align="middle" className={styles.recordDataRow}>
    <Col span={9}>
      <Flex align="center" gap={spacings.XS} style={{ minWidth: 0 }}>
        <code className={styles.code}>{record.host}</code>
        <CopyButton value={record.host} />
      </Flex>
    </Col>
    <Col span={3}>
      <span className={styles.recordType}>{record.type}</span>
    </Col>
    <Col span={12}>
      <Flex align="center" gap={spacings.XS} style={{ minWidth: 0 }}>
        <code className={styles.code}>{record.value}</code>
        <CopyButton value={record.value} />
      </Flex>
    </Col>
  </Row>
)

RecordRow.propTypes = {
  record: PropTypes.shape({
    host: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }).isRequired
}

export const DkimRecordsTable = ({ records, spfRecord }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.recordsTable}>
      <Row gutter={12} className={styles.recordHeaderRow}>
        <Col span={9}>{t("customEmail.dkim.col_name")}</Col>
        <Col span={3}>{t("customEmail.dkim.col_type")}</Col>
        <Col span={12}>{t("customEmail.dkim.col_value")}</Col>
      </Row>

      {records.map((record) => (
        <RecordRow key={record.host} record={record} />
      ))}

      {spfRecord && <RecordRow record={spfRecord} />}
    </div>
  )
}

DkimRecordsTable.propTypes = {
  records: PropTypes.arrayOf(PropTypes.shape({
    host: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  spfRecord: PropTypes.shape({
    host: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })
}
